import React from "react"
import {Box, Button, Grid, IconButton, Paper, Typography} from "@mui/material"
import {styled} from "@mui/material/styles"
import AddCircleOutlineIcon from "@mui/icons-material/AddCircleOutline"
import DeleteOutlineIcon from "@mui/icons-material/DeleteOutline"
import Content from "../../../components/Content"
import {checkConditionalMerkmalInRubrik} from "../../../misc/condition-merkmal"

const Header = styled(Box)(({theme}) => theme.FRAGEKATALOG.QuestionMulti.Header)
const ButtonGrid = styled(Box)(
    ({theme}) => theme.FRAGEKATALOG.QuestionMulti.ButtonGrid,
)
const ActionButton = styled(IconButton)(
    ({theme}) => theme.FRAGEKATALOG.QuestionMulti.ActionButton,
)
const NavButton = styled(Button, {
    shouldForwardProp: (prop) => prop !== "active",
})(({theme, active}) => theme.FRAGEKATALOG.QuestionMulti.NavButton(active))

const QuestionMultiCard = ({
    questionaire,
    questiongroup,
    questionList,
    value,
    currentIndex,
    setCurrentIndex,
    handleAdd,
    handleDelete,
    widgetLists,
    getDataFromPointer
}) => {
    const showAddButton = questionaire?.maxAmount === "LIMITED"
        ? Number.parseInt(questionaire?.maxAmountValue) > value?.length
        : true

    return (
        <Paper
            sx={{padding: 3}}
            variant="outlined">
            <Header>
                <Typography
                    variant="h5"
                    sx={{fontWeight: 700}}>
                    {questiongroup.longname}
                </Typography>
                <Grid
                    container
                    spacing={2}>
                    {value.length > 0 && (
                        <ActionButton
                            onClick={handleDelete}
                            color="primary">
                            <DeleteOutlineIcon />
                        </ActionButton>
                    )}
                    {showAddButton && <ActionButton
                        onClick={handleAdd}
                        color="primary">
                        <AddCircleOutlineIcon />
                    </ActionButton>}
                </Grid>
            </Header>

            {value.length > 0 && (
                <Box sx={{display: "flex", flexDirection: "column", gap: 2}}>
                    {widgetLists.map((widget, index) => (
                        checkConditionalMerkmalInRubrik(questionList[index], questiongroup, getDataFromPointer, currentIndex) && <Content
                            key={`${currentIndex}-${index}`}
                            child={widget}
                        />
                    ))}
                </Box>
            )}

            {value.length > 0 && (
                <ButtonGrid>
                    {value.map((_, index) => (
                        <NavButton
                            key={index}
                            active={index === currentIndex}
                            onClick={() => setCurrentIndex(index)}>
                            {index + 1}
                        </NavButton>
                    ))}
                </ButtonGrid>
            )}
        </Paper>
    )
}

export default QuestionMultiCard
